import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17 8V5c0-2.757-2.243-5-5-5S7 2.243 7 5v3H4v12h16V8h-3Zm-2 0H9V5c0-1.654 1.346-3 3-3s3 1.346 3 3v3Zm-1 5a2 2 0 0 1-1 1.732V17h-2v-2.268A2 2 0 0 1 12 11a2 2 0 0 1 2 2Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }